module.exports = __webpack_public_path__ + "img/hero-1-img.d22faa42.png";